import { useQuery } from "@tanstack/react-query";
import { getUserActivity } from "apis/user";
import UserAndMagnetActivityCard from "components/atoms/cards/user/UserAndMagnetActivityCard";
import { LoadingIcon } from "components/atoms/Icon";
import { useUserContext } from "components/context/UserContext";
import { useRouter } from "components/hooks";
import { get } from "utils/request";

type Props = {
  isPublicProfile: boolean;
};

function ActivityPanel({ isPublicProfile }: Props) {
  const { userDetails } = useUserContext();

  const { query } = useRouter();

  // This is a
  const { userId } = query;

  const userName = isPublicProfile ? userId : userDetails?.username;

  const { data: userActivity, isLoading } = useQuery<MagnetAndUserActivity[] | null>({
    queryKey: ["userActivity", userName],
    queryFn: () => get(getUserActivity(userName as string)),
    enabled: !!userName,
  });

  return (
    <div className="secondary-scrollbar grow overflow-scroll rounded-2xl  xl:border xl:border-secondary ">
      <div className="relative hidden xl:block">
        <div className="w-full  p-2.5">
          <p className="font-satoshi text-xxs font-bold text-white xl:text-xs 4xl:text-sm">{`${
            !isPublicProfile ? "My" : ""
          } Activity`}</p>
          <div className="absolute left-0 top-0 z-10 h-full w-full bg-gradient-to-l  from-[#ffffff33] to-[#fff]  opacity-30 " />
        </div>
      </div>
      <div
        className="secondary-scrollbar div mb-6 mt-5 flex flex-col gap-y-1 divide-y-1
        divide-white divide-opacity-30 overflow-scroll overflow-x-clip  pr-2 lg:mt-0 xl:px-4"
      >
        {isLoading ? (
          <div className="flex w-full items-center justify-center">
            <div className="h-32 w-32">
              <LoadingIcon color="#102D4E" />
            </div>
          </div>
        ) : (
          userActivity?.map((activity) => (
            <UserAndMagnetActivityCard
              key={activity.id}
              title={activity.title}
              createdAt={activity.created_at}
              navigationLink={activity.cta}
              // @ts-ignore
              imageUrl={activity.image_url}
              subType={activity.sub_type}
              actionType={activity.action_type}
              additionalClasses="!rounded-none !px-0"
            />
          ))
        )}
      </div>
    </div>
  );
}
export default ActivityPanel;
